import { Collapse } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.homepage-alert').forEach((alert) => {

    if (window.localStorage['ArdentCUHomepageAlert-' + alert.getAttribute('id')] == null) {
      window.localStorage['ArdentCUHomepageAlert-' + alert.getAttribute('id')] = 'no';
    }
    if (window.localStorage['ArdentCUHomepageAlert-' + alert.getAttribute('id')] == 'no') {
      Collapse.getOrCreateInstance(alert).show();
    }

    alert.querySelector('.dismiss').addEventListener('click', () => {
      window.localStorage['ArdentCUHomepageAlert-' + alert.getAttribute('id')] = 'yes';
    });
  });

})